<template> 
    <div class="news-hot">
        <div class="news-hot__title">
            <img src="@/assets/news/icon_hot.png" srcset="@assets/news/icon_hot@2x.png 2x" alt="" />
            {{ lang.hotTitle }}
        </div>

        <div class="news-hot__list">
            <div v-for="(item, index) in newsList" :key="index" class="news-hot__item" @click="handleClick(item)">
                <div class="news-hot__item-type">{{ index + 1 }}</div>
                <div>
                    <div class="news-hot__item-title"> {{ item.title }} </div>
                    <div class="news-hot__item-time">{{ dayjs(item.publish_time).fromNow() }}</div>
                </div>
            </div>
        </div>

        <div class="news-hot__more" @click="handleClickMore(10)" v-if="articleParam.page_size == 4">
            {{ lang.hotMore }}
        </div>
        <div class="news-hot__more" @click="handleClickMore(4)" v-if="articleParam.page_size == 10">
           {{ lang.hotHide }}
        </div>
    </div> 
</template>

<script setup>
    import { onMounted, ref } from 'vue';
    import { ArticleListAPI } from '@/api/common.js';
    import dayjs from 'dayjs';
    // 加载dayjs的relativeTime插件， 用来格式化相对时间，比如“xxx天前”
    import relativeTime from 'dayjs/plugin/relativeTime';
    import 'dayjs/locale/zh-cn';
    import 'dayjs/locale/zh-tw';
    dayjs.extend(relativeTime);
    
    // 热门参数
    import { useRouter } from 'vue-router'
    const router = useRouter()

    // 语言包
    const language = localStorage.getItem("language") || "zh"
    const lang = ref({})
    import(`@/language/${language}.js`).then(data => {
        lang.value = data.default.news
    }) 

    // relativeTime插件切换语言
    dayjs.locale(language == 'en' ? 'en' : language == 'tw' ? 'zh-tw' : 'zh-cn' ); 

    // 热门参数
    const articleParam = ref({
        is_hot: true,
        page: 1,
        page_size: 4
    })

    // 热门列表
    const newsList = ref([])

    // 热门获取
    const getNewsList = () => {
        ArticleListAPI(articleParam.value).then(res => {
            newsList.value = res.list
        });
    }

    // 点击跳转
    const handleClick = (item) => {
        router.push({ path: `/article/${item.id}` })
    }

    // 
    const handleClickMore = (page_size) => {
        articleParam.value.page_size = page_size
        getNewsList()
    }

    onMounted(() => {
        getNewsList()
    })

</script>

<style lang="scss" scoped>
    .news-hot {
        width: 306px;
        border-radius: 30px;
        background-color: #FFFFFF;
        border: 1px solid rgba(13, 42, 85, 0.2);
        padding: 24px;
        box-sizing: border-box;
        height: auto;

        &__title {
            font-family: PingFangSC-medium;
            color: #231917;
            font-weight: 500;
            font-size: 16px;
            line-height: 24px;
            display: flex;
            align-items: center;
            margin-bottom: 24px;
            
            img {
                margin-right: 8px;
            }
        }

        &__item {
            display: flex;
            margin-top: 16px;
            cursor: pointer;

            &:hover .news-hot__item-title {
                color: #0C3B81;
            }

            &-type {
                font-family: D-DIN-Bold;
                color: #0C3B81;
                font-weight: 700;
                font-size: 18px;
                line-height: 28px;
                margin-right: 10px;
            }

            &-title {
                font-family: PingFangSC-medium;
                color: #231917;
                font-weight: 500;
                font-size: 14px;
                line-height: 19px;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            &-time {
                color: #999999;
                font-weight: 400;
                font-size: 12px;
                line-height: 16px;
                margin-top: 9px;
            }
        }

        &__more {
            font-family: PingFangSC-medium;
            color: #0E4EAD;
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
            text-align: center;
            margin-top: 24px;
            cursor: pointer;
        }

        &__more:hover {
            opacity: .75;
        }

    }

</style>

